import { readStates } from '@/constants/lifecycle';

const cohortVisualisationActions = {
  SHOW_COHORT_VISUALISATION: 'SHOW_COHORT_VISUALISATION',
  SHOW_COHORT_VISUALISATION_ERROR: 'SHOW_COHORT_VISUALISATION_ERROR',
  TOGGLE_COHORT_VISUALISATION_SELECTED: 'TOGGLE_COHORT_VISUALISATION_SELECTED',
  FETCH_COHORT_VISUALISATION_BAR_QUERY: 'FETCH_COHORT_VISUALISATION_BAR_QUERY',
  FETCH_COHORT_VISUALISATION_BOX_PLOT_QUERY: 'FETCH_COHORT_VISUALISATION_BOX_PLOT_QUERY',
  FETCH_COHORT_VISUALISATION_STACKED_BAR_QUERY: 'FETCH_COHORT_VISUALISATION_STACKED_BAR_QUERY',
  FETCH_COHORT_VISUALISATION_HISTOGRAM_QUERY: 'FETCH_COHORT_VISUALISATION_HISTOGRAM_QUERY',
  CHANGE_COHORT_VISUALISATION_Y_AXIS: 'CHANGE_COHORT_VISUALISATION_Y_AXIS',
  CHANGE_COHORT_VISUALISATION_X_AXIS: 'CHANGE_COHORT_VISUALISATION_X_AXIS',
  CHANGE_COHORT_VISUALISATION_BINS: 'CHANGE_COHORT_VISUALISATION_BINS',
  REFRESH_COHORT_VISUALISATION: 'REFRESH_COHORT_VISUALISATION',
};

export const cohortChart = {
  BAR: 'bar',
  STACKED_BAR: 'stackedBar',
  BOX_PLOT: 'box',
  HISTOGRAM: 'histogram',
};

export const cohortAxis = {
  X_AXIS: 'x_axis',
  Y_AXIS: 'y_axis',
};

export const binsValues = [10, 15, 20];

export const INVALID_CHART_SERIES_COLOUR = '#FF0000';

export const cohortVisualisationStates = {
  ...readStates,
};

export default cohortVisualisationActions;
